import { h, Fragment } from 'preact';
import AddToCartButton from './add-to-cart-button';
import BisModal from './bis-modal';
import LowInventoryBadge from './low-inventory-badge';
import Price from './price';
import ProductBadge from './product-badge';
import ProductTitle from './product-title';
import VariantSelectorGroup from './variant-selector-group';
import KitAddToCartButton from './kit/add-to-cart-button';
import KitPrice from './kit/price';
import KitProductSelectorGroup from './kit/product-selector-group';
import ShopPay from './shop-pay';
import { useProduct } from './product-context';

const ProductForm = () => {
  const { activeProduct, activeVariant, isKit } = useProduct();
  const badgeTag = activeProduct.tags.find((tag) => tag.includes('badge'));

  const SingleProductForm = () => (
    <div className="py-[35px] product-buy-box bg-white">
      <BisModal />
      {badgeTag ? <ProductBadge badge={badgeTag.split('::')[1]} /> : null}
      <ProductTitle />
      <Price />
      <VariantSelectorGroup />
      <LowInventoryBadge />
      {activeVariant && <AddToCartButton />}
      <ShopPay />
    </div>
  );

  const KitProductForm = () => (
    <div className="py-[35px] product-buy-box bg-white">
      {badgeTag ? <ProductBadge badge={badgeTag.split('::')[1]} /> : null}
      <ProductTitle />
      <KitPrice />
      <KitProductSelectorGroup />
      <LowInventoryBadge />
      <KitAddToCartButton />
    </div>
  );

  return isKit ? <KitProductForm /> : <SingleProductForm />;
};

export default ProductForm;
